/**
 * @description
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
}

interface IOutput {
    status: boolean;
}

export const publishResources = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.LIVE_RESOURCE_PUBLISH, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
